import {
  CreateTaskForSalesSuccess,
  ESalesChangesActions,
  SalesChangesActions,
} from '@myStore/sales-changes/sales-changes.actions';
import {
  initialsSalesChangesState,
  ISalesChangesState,
} from '@myStore/sales-changes/sales-changes.state';

export const salesChangesReducers = (
  state = initialsSalesChangesState,
  actions: SalesChangesActions
): ISalesChangesState => {
  switch (actions.type) {
    case ESalesChangesActions.ClearSalesChangesErrors:
      return initialsSalesChangesState;
    case ESalesChangesActions.GetAccessToEditLeadDataRequest:
      return {
        ...state,
        isLoading: true,
        getAccessToEditSuccess: false,
        errors: null,
      };
    case ESalesChangesActions.GetAccessToEditLeadDataSuccess:
      return {
        ...state,
        isLoading: false,
        getAccessToEditSuccess: true,
      };
    case ESalesChangesActions.GetAccessToEditLeadDataFailure:
      return {
        ...state,
        isLoading: false,
        getAccessToEditSuccess: false,
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearGetAccessToEditLeadDataErrors:
      return {
        ...state,
        isLoading: false,
        getAccessToEditSuccess: false,
        errors: null,
      };

    case ESalesChangesActions.SendPresentationApplicationRequest:
    case ESalesChangesActions.AddLeadByHandRequest:
    case ESalesChangesActions.AddEnrolleeByHandRequest:
    case ESalesChangesActions.DeleteEnrolleeRequest:
    case ESalesChangesActions.DeleteDealRequest:
    case ESalesChangesActions.IndicateLeadToCourseAndGroupRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
        errors: null,
      };
    case ESalesChangesActions.SendPresentationApplicationSuccess:
    case ESalesChangesActions.AddLeadByHandSuccess:
    case ESalesChangesActions.AddEnrolleeByHandSuccess:
    case ESalesChangesActions.DeleteEnrolleeSuccess:
    case ESalesChangesActions.DeleteDealSuccess:
    case ESalesChangesActions.IndicateLeadToCourseAndGroupSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case ESalesChangesActions.SendPresentationApplicationFailure:
    case ESalesChangesActions.AddLeadByHandFailure:
    case ESalesChangesActions.AddEnrolleeByHandFailure:
    case ESalesChangesActions.DeleteEnrolleeFailure:
    case ESalesChangesActions.DeleteDealFailure:
    case ESalesChangesActions.IndicateLeadToCourseAndGroupFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearSendPresentationApplicationErrors:
    case ESalesChangesActions.ClearAddLeadByHandErrors:
    case ESalesChangesActions.ClearDeleteEnrolleeErrors:
    case ESalesChangesActions.ClearDeleteDealErrors:
    case ESalesChangesActions.ClearAddEnrolleeByHandErrors:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: null,
      };

    case ESalesChangesActions.ChangePresentationInfoRequest:
    case ESalesChangesActions.ChangeEnrollDataInPresentationRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
        errors: null,
      };
    case ESalesChangesActions.ChangePresentationInfoSuccess:
    case ESalesChangesActions.ChangeEnrollDataInPresentationSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case ESalesChangesActions.ChangePresentationInfoFailure:
    case ESalesChangesActions.ChangeEnrollDataInPresentationFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearChangePresentationInfoErrors:
    case ESalesChangesActions.ClearChangeEnrollDataInPresentationErrors:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: null,
      };

    case ESalesChangesActions.MakeCourseRecruitmentRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
        errors: null,
      };
    case ESalesChangesActions.MakeCourseRecruitmentSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case ESalesChangesActions.MakeCourseRecruitmentFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearMakeCourseRecruitmentErrors:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: null,
      };

    case ESalesChangesActions.ChangeLeadDataRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
        errors: null,
      };
    case ESalesChangesActions.ChangeLeadDataSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
        errors: null,
      };
    case ESalesChangesActions.ChangeLeadDataFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearChangeLeadDataErrors:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: null,
      };

    case ESalesChangesActions.CreateTaskForSalesRequest:
    case ESalesChangesActions.UpdateTaskForSalesRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
        errors: null,
        newTask: {
          ...state.newTask,
          task: null,
          loading: false,
          success: false,
        },
      };
    case ESalesChangesActions.CreateTaskForSalesSuccess:
    case ESalesChangesActions.UpdateTaskForSalesSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
        errors: null,
        newTask: {
          ...state.newTask,
          task:
            actions instanceof CreateTaskForSalesSuccess ? actions.task : null,
          loading: false,
          success: true,
        },
      };
    case ESalesChangesActions.CreateTaskForSalesFailure:
    case ESalesChangesActions.UpdateTaskForSalesFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
        newTask: {
          ...state.newTask,
          task: null,
          loading: false,
          success: false,
        },
      };
    case ESalesChangesActions.ClearCreateTaskForSalesErrors:
    case ESalesChangesActions.ClearUpdateTaskForSalesErrors:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: null,
        newTask: {
          task: null,
          loading: false,
          success: false,
        },
      };

    case ESalesChangesActions.AddFileToTaskRequest:
      return {
        ...state,
        files: {
          loading: true,
          success: false,
        },
        errors: null,
      };

    case ESalesChangesActions.AddFileToTaskSuccess:
      return {
        ...state,
        files: {
          loading: false,
          success: true,
        },
      };
    case ESalesChangesActions.AddFileToTaskFailure:
      return {
        ...state,
        isLoading: false,
        files: {
          loading: false,
          success: false,
        },
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearAddFileToTaskErrors:
      return {
        ...state,
        files: {
          loading: false,
          success: false,
        },
        errors: null,
      };

    case ESalesChangesActions.DeleteFileFromTaskRequest:
      return {
        ...state,
        files: {
          loading: true,
          success: false,
        },
        errors: null,
      };
    case ESalesChangesActions.DeleteFileFromTaskSuccess:
      return {
        ...state,
        files: {
          loading: false,
          success: true,
        },
        errors: null,
      };
    case ESalesChangesActions.DeleteFileFromTaskFailure:
      return {
        ...state,
        files: {
          loading: false,
          success: false,
        },
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearDeleteFileFromTaskErrors:
      return {
        ...state,
        files: {
          loading: false,
          success: false,
        },
        errors: null,
      };

    case ESalesChangesActions.AddContractCredentialsRequest:
    case ESalesChangesActions.EditContractCredentialsRequest:
      return {
        ...state,
        errors: null,
      };

    case ESalesChangesActions.AddContractCredentialsSuccess:
    case ESalesChangesActions.EditContractCredentialsSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case ESalesChangesActions.AddContractCredentialsFailure:
    case ESalesChangesActions.EditContractCredentialsFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearAddContractCredentialsErrors:
    case ESalesChangesActions.ClearEditContractCredentialsErrors:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: null,
      };

    case ESalesChangesActions.ChangeTaskExecuterRequest:
      return {
        ...state,
        task_executer: {
          loading: true,
          success: false,
        },
        errors: null,
      };
    case ESalesChangesActions.ChangeTaskExecuterSuccess:
      return {
        ...state,
        task_executer: {
          loading: false,
          success: true,
        },
        errors: null,
      };
    case ESalesChangesActions.ChangeTaskExecuterFailure:
      return {
        ...state,
        task_executer: {
          loading: false,
          success: false,
        },
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearChangeTaskExecuter:
      return {
        ...state,
        task_executer: {
          loading: false,
          success: false,
        },
        errors: null,
      };

    case ESalesChangesActions.UpdateTaskDeadLineRequest:
      return {
        ...state,
        task_change_deadline: {
          loading: true,
          success: false,
        },
        errors: null,
      };

    case ESalesChangesActions.UpdateTaskDeadLineSuccess:
      return {
        ...state,
        task_change_deadline: {
          loading: false,
          success: true,
        },
        errors: null,
      };
    case ESalesChangesActions.UpdateTaskDeadLineFailure:
      return {
        ...state,
        task_change_deadline: {
          loading: false,
          success: false,
        },
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearUpdateTaskDeadLineErrors:
      return {
        ...state,
        task_change_deadline: {
          loading: false,
          success: false,
        },
        errors: null,
      };

    case ESalesChangesActions.ChangeSalesTaskStatusRequest:
      return {
        ...state,
        task_change_status: {
          loading: true,
          success: false,
        },
        errors: null,
      };

    case ESalesChangesActions.ChangeSalesTaskStatusSuccess:
      return {
        ...state,
        task_change_status: {
          loading: false,
          success: true,
        },
        errors: null,
      };
    case ESalesChangesActions.ChangeSalesTaskStatusFailure:
      return {
        ...state,
        task_change_status: {
          loading: false,
          success: false,
        },
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearChangeSalesTaskStatusErrors:
      return {
        ...state,
        task_change_status: {
          loading: false,
          success: false,
        },
        errors: null,
      };

    case ESalesChangesActions.GenerateContractToLeadRequest:
      return {
        ...state,
        lead_contract: {
          loading: true,
          success: false,
        },
        errors: null,
      };

    case ESalesChangesActions.GenerateContractToLeadSuccess:
      return {
        ...state,
        lead_contract: {
          loading: false,
          success: true,
        },
        errors: null,
      };
    case ESalesChangesActions.GenerateContractToLeadFailure:
      return {
        ...state,
        lead_contract: {
          loading: false,
          success: false,
        },
        errors: actions.errors,
      };

    case ESalesChangesActions.AddLeadDocumentsRequest:
    case ESalesChangesActions.DeleteLeadDocumentsRequest:
      return {
        ...state,
        lead_documents: {
          loading: true,
          success: false,
        },
        errors: null,
      };

    case ESalesChangesActions.AddLeadDocumentsSuccess:
    case ESalesChangesActions.DeleteLeadDocumentsSuccess:
      return {
        ...state,
        lead_documents: {
          loading: false,
          success: true,
        },
        errors: null,
      };
    case ESalesChangesActions.AddLeadDocumentsFailure:
    case ESalesChangesActions.DeleteLeadDocumentsFailure:
      return {
        ...state,
        lead_documents: {
          loading: false,
          success: false,
        },
        errors: actions.errors,
      };

    case ESalesChangesActions.CreateDealToLeadRequest:
    case ESalesChangesActions.CloseDealToLeadRequest:
      return {
        ...state,
        lead_deal: {
          loading: true,
          success: false,
          message: null,
        },
      };
    case ESalesChangesActions.CreateDealToLeadSuccess:
      return {
        ...state,
        lead_deal: {
          loading: false,
          success: true,
          message: null,
        },
      };
    case ESalesChangesActions.CloseDealToLeadSuccess:
      return {
        ...state,
        lead_deal: {
          loading: false,
          success: true,
          message: actions.message,
        },
      };

    case ESalesChangesActions.CreateDealToLeadFailure:
    case ESalesChangesActions.CloseDealToLeadFailure:
      return {
        ...state,
        lead_deal: {
          loading: false,
          success: false,
          message: null,
        },
        errors: actions.errors,
      };
    case ESalesChangesActions.EditDealRequest:
      return {
        ...state,
        edit_deal: {
          loading: false,
          success: false,
        },
        errors: null,
      };

    case ESalesChangesActions.EditDealSuccess:
      return {
        ...state,
        edit_deal: {
          loading: false,
          success: true,
        },
        errors: null,
      };
    case ESalesChangesActions.EditDealFailure:
      return {
        ...state,
        edit_deal: {
          loading: false,
          success: false,
        },
        errors: actions.errors,
      };

    case ESalesChangesActions.AddPaymentNoteRequest:
      return {
        ...state,
        payment_note: {
          loading: true,
          success: false,
        },
        errors: null,
      };

    case ESalesChangesActions.AddPaymentNoteSuccess:
      return {
        ...state,
        payment_note: {
          loading: false,
          success: true,
        },
        errors: null,
      };
    case ESalesChangesActions.AddPaymentNoteFailure:
      return {
        ...state,
        payment_note: {
          loading: false,
          success: false,
        },
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearAddPaymentNoteErrors:
      return {
        ...state,
        payment_note: {
          loading: false,
          success: false,
        },
        errors: null,
      };
    case ESalesChangesActions.AddDiscountRequest:
    case ESalesChangesActions.DeleteDiscountLeadRequest:
    case ESalesChangesActions.EditDiscountRequest:
      return {
        ...state,
        isLoading: true,
        success: false,
      };
    case ESalesChangesActions.AddDiscountSuccess:
    case ESalesChangesActions.DeleteDiscountLeadSuccess:
    case ESalesChangesActions.EditDiscountSuccess:
      return {
        ...state,
        isLoading: false,
        success: true,
      };
    case ESalesChangesActions.AddDiscountFailure:
    case ESalesChangesActions.DeleteDiscountLeadFailure:
    case ESalesChangesActions.EditDiscountFailure:
      return {
        ...state,
        isLoading: false,
        success: false,
        errors: actions.errors,
      };
    case ESalesChangesActions.AddDiscountForLeadRequest:
      return {
        ...state,
        discount_for_lead: {
          loading: true,
          success: false,
        },
        errors: null,
      };
    case ESalesChangesActions.AddDiscountForLeadSuccess:
      return {
        ...state,
        discount_for_lead: {
          loading: false,
          success: true,
        },
        errors: null,
      };
    case ESalesChangesActions.AddDiscountForLeadFailure:
      return {
        ...state,
        discount_for_lead: {
          loading: false,
          success: false,
        },
        errors: actions.errors,
      };

    case ESalesChangesActions.AddDiscountForStudentRequest:
      return {
        ...state,
        discount_for_student: {
          loading: true,
          success: false,
        },
        errors: null,
      };
    case ESalesChangesActions.AddDiscountForStudentSuccess:
      return {
        ...state,
        discount_for_student: {
          loading: false,
          success: true,
        },
        errors: null,
      };
    case ESalesChangesActions.AddDiscountForStudentFailure:
      return {
        ...state,
        discount_for_student: {
          loading: false,
          success: false,
        },
        errors: actions.errors,
      };
    case ESalesChangesActions.ConvertEnrolleeToLeadRequest:
      return {
        ...state,
        convert_to_lead: {
          ...state.convert_to_lead,
          loading: true,
          success: false,
        },
        errors: null,
      };
    case ESalesChangesActions.ConvertEnrolleeToLeadSuccess:
      return {
        ...state,
        convert_to_lead: {
          ...state.convert_to_lead,
          loading: true,
          success: true,
        },
      };
    case ESalesChangesActions.ConvertEnrolleeToLeadFailure:
      return {
        ...state,
        convert_to_lead: {
          ...state.convert_to_lead,
          loading: false,
          success: false,
        },
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearConvertEnrolleeToLeadErrors:
      return {
        ...state,
        convert_to_lead: {
          ...state.convert_to_lead,
          loading: false,
          success: false,
        },
        errors: null,
      };

    case ESalesChangesActions.EditEnrolleeRequest:
      return {
        ...state,
        edit_enrollee: {
          loading: true,
          success: false,
        },
        errors: null,
      };
    case ESalesChangesActions.EditEnrolleeSuccess:
      return {
        ...state,
        edit_enrollee: {
          loading: false,
          success: true,
        },
        errors: null,
      };
    case ESalesChangesActions.EditEnrolleeFailure:
      return {
        ...state,
        edit_enrollee: {
          loading: false,
          success: false,
        },
        errors: actions.errors,
      };
    case ESalesChangesActions.ClearEditEnrolleeErrors:
      return {
        ...state,
        edit_enrollee: {
          loading: false,
          success: false,
        },
        errors: null,
      };
  }
  return state;
};
